/*eslint-disable*/
import React, { useState, useEffect } from "react";

import APIClient from "../client";
import config from "../config.js"
import TableChart from "../components/Charts/TableChart.js";
import PlatformDisbursementChart from "../components/Charts/PlatformDisbursements.js";
import DisplayNameDropdown from "../components/dropdowns/DisplayNameDropdown.js";
import AuthNavbar from "../components/Navbars/AuthNavbar.js";

import '../assets/styles/App.css';
import '../assets/styles/tailwind.css';
import "@fontsource/montserrat";


const client = new APIClient(config);


export default function FunderMandates() {
  const [data, setData] = useState(null);
  const [columnData, setColumnData] = useState(null);
  const [funderArray, setFunderArray] = useState(null);
  const [disbursementArray, setDisbursementArray] = useState(null);

  const [dropDowndata, setDropDown] = useState(null);
  const [selected, setSelected] = useState('monthly');

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setDropDown([
        {"id": "monthly", "display_name": "Last Month"},
        {"id": "rolling_12_months", "display_name": "Rolling 12 Months"},
      ]);
    fetchFunderMandates();
  }, []);


  function transformObject(in_obj){ 
    let partners = in_obj.map( (item) => item.partner + ' - ' + item.funder);
    let disbursements = in_obj.map((item) => item.disbursed_usd);

    setFunderArray(partners);
    setDisbursementArray(disbursements);
  }; 

  const fetchFunderMandates = (event) => {
    const value = (!event) ? selected : event;

    if(value != "Select the aggregation level") {

      client.getFunderMandate(value).then((data) => {
        transformObject(data['data']['data']);
        setData(data['data']['data']);
        const columns = [
          {
            name: "Partner",
            sortable: true,
            selector: (row) => row.partner,
          },
          {
            name: "Funder",
            sortable: true,
            selector: (row) => row.funder,
          },
          {
            name: "reporting_date",
            omit: true,
            selector: (row) => row.reporting_date,
          },
          {
            name: "current_month",
            omit: true,
            selector: (row) => row.current_month,
          },
          {
            name: "Disbursed (Local)",
            selector: (row) => row.disbursed_local.toLocaleString(),
          },
          {
            name: "Disbursed (USD)",
            omit: true,
            selector: (row) => row.disbursed_usd.toLocaleString(undefined, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }),
          },
          {
            name: "Current Yield",
            sortable: true,
            selector: (row) => row.current_yield.toLocaleString() + '%',
            style: {backgroundColor: '#2c3674'},
          },

          {
            name: "Current Collection Rate",
            selector: (row) => row.current_collection_rate.toLocaleString() + '%',
            style: {backgroundColor: '#2c3674'},
          },
          {
            name: "month_count",
            omit: true,
            selector: (row) => row.month_count,
          },
          {
            name: "Cumulative Yield",
            selector: (row) => row.cumulative_yield.toLocaleString() + '%',
            style: {backgroundColor: '#2c3674'},
          },
          {
            name: "Cumulative Collection Rate",
            selector: (row) => row.cumulative_collection_rate.toLocaleString() + '%',
            style: {backgroundColor: '#2c3674'},
          },
          {
            name: "Yield Target",
            selector: (row) => row.yield_target.toLocaleString() + '%',
            style: {backgroundColor: '#2c3674'},
          },
          {
            name: "COR Target",
            selector: (row) => row.cor_target.toLocaleString() + '%',
            style: {backgroundColor: '#2c3674'},
          },
          {
            name: "aggregate",
            omit: true,
            selector: (row) => row.aggregate,
          },
          {
            name: "id",
            omit: true,
            selector: (row) => row.id,
          },
          {
            name: "updated_at",
            omit: true,
            selector: (row) => row.updated_at,
          },
        ];

        setColumnData(columns);
        setLoading(false);
        setError(null);
      });}
  };

  const screenSize = (window.innerWidth >= 912);
  const screenSizeTwo = (window.innerWidth >= 1024);

  document.title = "Funder";

  return (
    <>
      <section>
        <AuthNavbar />
      </section>

      <section className="relative grad-1 pb-20">
        <div className="container relative mx-auto pt-12 px-4 w-10/12">
          {loading && (
            <div className="text-xl text-yellow font-medium">Loading...</div>
          )}
          {error && <CardError message={error} />}

          {data && (

            <>
              <h2 className="text-36 text-yellow mb-3">Performance</h2>

              <div className="relative w-full px-4 mb-4">
                <div className="relative bg-white-2 w-full rounded-lg p-4">
                  <DisplayNameDropdown
                    options={dropDowndata}
                    selected=""
                    onSelectedChange={fetchFunderMandates}
                  />
                </div>
              </div>

              <div className="relative w-full px-4 mb-4">
                  <div className="relative bg-white-2 w-full rounded-lg p-4">
                  <PlatformDisbursementChart
                          disbursements={disbursementArray}
                          labels={funderArray}
                          title='Funder Disbursement Values (USD)'
                      />
                  </div>
              </div>

              <div className="relative w-full px-4 mb-8">
                <div className="relative bg-white-2 w-full rounded-lg p-4 mb-8 text-white">
                  <TableChart
                      columns={columnData}
                      data={data}
                      defaultSortFieldId={1}
                  /><i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                   &nbsp;Cumulative defined as last 12 months average of 150dpd and overall yield
                </div>
              </div>


            </>




          )}

        </div>
      </section>

    </>
  );
}

